<template lang="pug">
  v-layout(class='wrp' fill-height column)
    v-flex(class='dflex-auto heading')
      section(class='wrp-head')
        s-page-title(:previous='true' title='Инфраструктура')
    v-flex(class='wrap-all dflex-item relative')
      div(class='wrp-scroll')
        infrastructure
</template>

<script>
export default {
  components: {
    Infrastructure: () => import('@/components/async/Infrastructure')
  }
}
</script>

<style scoped>
.heading {
  flex: 0 0 auto;
}
.wrap-all {
  flex: 1;
  position: relative;
}
.wrp {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  max-width: 100%;
  overflow: hidden;
}
.wrp-head {
  z-index: 2;
  width: 100%;
  padding: 24px;
  padding-bottom: 0;
  background: white;
  position: relative;
}
.wrp-body {
  position: relative;
}
.wrp-scroll {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  overflow: hidden;
}
.wrp >>> .header {
  margin-bottom: 0 !important;
  padding-bottom: 16px !important;
}
</style>
